<template>
    <readout-group-list
        :abstractSchemaConfig="protocol"
        :readout-groups="readoutGroups"
        @create="createReadoutGroup"
        @update="updateReadoutGroup"
        @delete="deleteReadoutGroup"
    />
</template>
<script>
import { defineComponent } from "vue";

import { buildProtocolReadoutGroupsAPI } from "@/services/api.services";
import ReadoutGroupList from "../Measurements/ReadoutGroupList.vue";
import { withLoadingScreen } from "@/lib/loading";

export default defineComponent({
    components: { ReadoutGroupList },

    props: {
        protocol: {
            type: Object,
            required: true,
        },
        readoutGroups: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            protocolReadoutGroupsAPI: null,
        };
    },

    async mounted() {
        this.protocolReadoutGroupsAPI = buildProtocolReadoutGroupsAPI(this.protocol.code);
    },

    methods: {
        createReadoutGroup(readoutGroup) {
            return this.save(() => this.protocolReadoutGroupsAPI.create(readoutGroup));
        },
        updateReadoutGroup(readoutGroup) {
            return this.save(() => this.protocolReadoutGroupsAPI.update(readoutGroup));
        },
        async save(saveFn) {
            return withLoadingScreen(async () => {
                await saveFn();
                this.$emit("saved");
            });
        },
        async deleteReadoutGroup(readoutGroup) {
            return withLoadingScreen(async () => {
                await this.protocolReadoutGroupsAPI.delete(readoutGroup.id);
                this.$emit("deleted");
            });
        },
    },
});
</script>
<style></style>
